import Multiselect from "../Common/MultiSelect";

const Categories = ({ data, catHandleChangeMultiBox, categories }) => {
    return (
      <Multiselect name="categories" options={data} displayValue="id"  selectedValues={categories} onSelect={catHandleChangeMultiBox} onRemove={catHandleChangeMultiBox} />
    );
}

export default Categories;